import storeENUM from './enum';
import now from './now';
import date from './date';
import truncate from './truncate';
import size from './size';
import capitalize from './capitalize';
import linebreak from './linebreak';
import ucwords from './ucwords';
import currency from './currency';

export default {
	storeENUM,
	now,
	date,
	truncate,
	size,
	capitalize,
	linebreak,
	ucwords,
	currency
};



// WEBPACK FOOTER //
// ./sources/filters/index.js